import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@medflex/components/stories/Button';
import Modal from '@medflex/components/stories/Modal';
import { showAlertToast, showSuccessToast } from '@medflex/components/stories/Toast';
import { trackEvent } from '@medflex/utils/Tracking';
import Logger from '@medflex/utils/Logger';
import useLocationSearchParams from '../../hooks/useLocationSearchParams';
import useSessionMeetings from '../hooks/useSessionMeetings';
import useModal from '../hooks/useModal';

const SessionsResendModule = () => {
  const { t } = useTranslation('global');
  const { close } = useModal();
  const { sessionId } = useLocationSearchParams();
  const { resend, isResendingInvitation, getMeetingById, getDateFormatted } = useSessionMeetings();
  const meeting = getMeetingById(sessionId);
  const dateFormatted = getDateFormatted(meeting && meeting.scheduledAt);

  const handleClose = () => close({ modal: 'sessionsResend', sessionId });

  const handleSubmit = async event => {
    try {
      await resend(sessionId);
      trackEvent(event);
      showSuccessToast(t('sessions.SessionsResendModule.success'), null, {
        toastId: 'SessionResendSuccess',
      });
      handleClose();
    } catch (e) {
      showAlertToast(t('sessions.SessionsResendModule.failure'), null, {
        toastId: 'SessionResendFailed',
      });
      e.message = `SessionsResendModule#handleSubmit(): ${e.message}`;
      Logger.error(e);
    }
  };

  if (!meeting) {
    return null;
  }

  return (
    <Modal onClickCloseButton={handleClose} onClickOutside={handleClose} showCloseButton>
      <div data-component="SessionsResendModule" className="flex flex-col p-4">
        <h2 className="text-xl font-semibold mb-6 leading-none">
          {t('sessions.SessionsResendModule.title')}
        </h2>
        <p className="mb-4">
          {t('sessions.SessionsResendModule.text', {
            title: meeting.title,
            date: dateFormatted,
            allowHtml: true,
          })}
        </p>
        <Button className="self-center" isLoading={isResendingInvitation} onClick={handleSubmit}>
          {t('sessions.SessionsResendModule.submit')}
        </Button>
      </div>
    </Modal>
  );
};

export default SessionsResendModule;
